import PQueue from "p-queue";

import useLog from "./hooks/useLog";
import { prepopulated_cache } from "./resources/caches/prepopulated_cache";
import { deepcopy } from "./shared/helpers";
import { getLog, isElectron } from "./helpers/helpers";
import Constants from "./config.js";
// import { is_web_app } from "./App.js";

// queue that executes only one entry per 1.5 second
const queue = new PQueue({
	concurrency: 1, // concurrency option limits how many things run at the same time.
	autoStart: true,
	interval: 1500, // in ms
	intervalCap: 1, // intervalCap limits how many things run in total during the interval (over time).
	carryoverConcurrencyCount: true,
});

const IGNORE_BANS = false

//
//   PERSISTED CACHE ON DISK FOR RUN txs
//
// 	beware this is actually MUCH TOO SLOW if we save to disk synchronously on all set(),
//  it will freezes the app, we need to make the writing to disk asynchronous
//  and debouncer like 1/s max or even 1/10s, so we collect all during 10s and then write all at once

export default class RunFileStore {
	constructor(filestore_name) {
		this.classname = "RunFileStore: ";
		const function_id = this.classname + "constructor(): ";
		const log = (...args) => {
			console.log(function_id, ...args);
		};

		log("creating");
		// load the store from file if we are in production & already have one
		try {
			this.filestore = get_store_WalletHistoryCache(
				filestore_name + "_RUNcache"
			); // will return null if not in production
		} catch (error) {
			throw new Error(function_id + ".:1 " + error.toString());
		}

		if (this.filestore) {
			try {
				// preopulated cache
				//
				// add prepopulated cache entries (without having to fetch online and do recursion on refs!)
				this.filestore.set(prepopulated_cache); // this should work to set many items at once, faster?
				log(
					"_RUNcache was prepopulated with # of entries:",
					Object.keys(prepopulated_cache).length
				);
				/* var keys=Object.keys(prepopulated_cache)
				var nb_already_set
				for(let i=0; i < keys.length; i++){
					var key = keys[i]
					let already_set = (this.cache && this.cache.hasOwnProperty(key))
					// log("prepopulated_cache, key=",key,", already_set=",already_set)
					if(!already_set){
						const val = prepopulated_cache[key]
						this.set(key, val) // this.set() will check if already in cache before setting anyway
					}
					else nb_already_set++
				}
				log("_RUNcache was prepopulated with # of entries:",keys.length,", nb_already_set=",nb_already_set)
				*/

				if (IGNORE_BANS) {
					log("this.filestore.size 1=", this.filestore.size)
					log("this.filestore=", this.filestore)
					let all_keys = Object.keys(this.filestore.store)
					let all_non_bans_keys = all_keys.filter(k => { return !k.startsWith("ban://") })
					log("found", all_non_bans_keys.length, "non_bans_keys")
					let all_non_bans_dict = {}
					for (let i = 0; i < all_non_bans_keys.length; i++) {
						let key = all_non_bans_keys[i]
						all_non_bans_dict[key] = this.filestore.store[key]
					}
					this.filestore.clear()
					this.filestore.set(all_non_bans_dict)
					all_keys = Object.keys(this.filestore.store)
					let all_bans_keys = all_keys.filter(k => { return k.startsWith("ban://") })
					log("all_bans_keys=", all_bans_keys)
					log("this.filestore.size 2=", this.filestore.size)
				}



				// we use an in-memory cache for faster loads & gets
				this.cache = deepcopy(this.filestore.store);
				// var temp_cache = []
				// var allkeys = Object.keys(this.cache)
				// log("allkeys = ",allkeys)
				// for(let i=0; i < allkeys.length; i++){
				// 	let key = allkeys[i]
				// 	temp_cache[key] = this.cache[key]
				// }
				// this.cache = temp_cache

				// save size
				// this.size = this.filestore.size

				log(
					"\n this.filestore.size =",
					this.filestore.size,
					"\n Object.keys(this.cache).length =",
					Object.keys(this.cache).length
				);

				//
				// access store with: this.filestore.store, or directly filestore.get() / set()
				//

			} catch (error) {
				throw new Error(function_id + ".2: " + error.toString());
			}
		}
	}

	get_path() {
		var path = this.filestore.path;
		if (path.includes("/")) {
			path = path.split("/").slice(0, -1).join("/");
		} else {
			path = path.split("\\").slice(0, -1).join("\\");
		}
		return path;
	}

	get_path_raw() {
		return this.filestore.path;
	}

	get_cache() {
		return this.cache;
	}

	get(key) {
		const function_id = this.classname + "get():";
		let log = getLog(function_id);
		try {
			// if(key.startsWith("ban://")) return false // to test not banning any tx on load

			/*
			let allkeys = Object.keys(this.cache)
			let found_in_cache = false
			for(let i=0; i<allkeys.length; i++){
				if(key === allkeys[i]) found_in_cache=true
			}
			if(found_in_cache) console.warn(function_id,"FOUND KEY:",key)
			else console.warn(function_id,"DID NOT FOUND KEY:",key)
			*/

			if (
				this.cache &&
				this.cache.hasOwnProperty(key) &&
				this.cache[key] !== undefined // I did a mistake that put undefined values into the caches, so let's correct it that way
			) {
				return this.cache[key];
			}
			/*
			// if key isn't in memory, we can try to get from disk
			// BUT THAT SLOWS THE APP DOWN LIKE HELL AND IS MOSTLY USELESS (since all disk is loaded into memory on start)
			else if(this.filestore){
				const val = this.filestore.get(key)
				if(val){ // value existed on disk but not in memory cache
					console.warn(function_id,"(shouldn't happen) needed to retrieve from disk for key=",key,"\n !!val=",!!val)
					this.cache[key] = val
					return val
				}
			}
			*/
		} catch (e) {
			throw new Error(function_id + "key=" + key + ": " + e.toString());
		}
	}

	set(key, value) {
		const function_id = this.classname + "set() with key=" + key + ": ";
		const log = getLog(function_id)

		if (value === undefined) return false;

		if (IGNORE_BANS) {
			if (key.startsWith("ban://")) return
		}

		try {
			// don't rewrite if already exists, we cannot change transactions anyway in this case
			// beware some values may contains "false" so we need to check for undefined
			if (
				this.cache &&
				this.cache.hasOwnProperty(key) &&
				this.cache[key] !== undefined
			) {
				return true;
			}

			// write to memory first and make an async call to write to disk
			this.cache[key] = value;

			// async call to write to disk (with debouncing)
			if (this.filestore) {
				// testing necessary for browser version

				// commenting because too slow!!
				// // safety check if already on disk
				// const get_key = this.filestore.get(key)
				// log("get_key = ",get_key)
				// if(get_key){
				// 	this.cache[key] = get_key
				// 	this.trusted_txids[txhash] = true
				// 	return true
				// }

				if (!this.toWriteToDiskDict) this.toWriteToDiskDict = {};

				this.toWriteToDiskDict[key] = value;

				this.async_write_to_disk();
			}

			return true;
		} catch (e) {
			if (isElectron()) {
				throw new Error("RunFileStore: set(): error:" + e.toString());
			}
		}
	}

	clearCache() {
		// clear cache on disk and in memory
		this.cache = {};
		if (this.filestore) this.filestore.clear(); // on disk
	}

	async async_write_to_disk() {
		const function_id = "async_write_to_disk(): ";
		const log = useLog(function_id);

		/* // old version, working but still too slow, freezes the app a bit
		if(!this.toWriteToDiskDict || Object.keys(this.toWriteToDiskDict.lengh===0)) return
		// Extract with copy to avoid conflicting edit issues
		// TODO improve with proper lock, but shouldn't be too much of an issue if we miss some from time to time
		// as they will just be written on the next wallet opening
		let _toWriteToDiskDict = deepcopy(this.toWriteToDiskDict)
		let keys_to_write = Object.keys(_toWriteToDiskDict)
		log("length=",keys_to_write.length)

		// very basic condition: write 1 every 10
		// TODO improve with timer, ex write 1 every 3s max
		// => use a queue & write every 3 secs?
		if(keys_to_write.length > 10){
			// remove those keys from those to write and actually write them to disk
			keys_to_write.forEach(key=>{
				delete this.toWriteToDiskDict[key]
			})
			this.filestore.set(_toWriteToDiskDict)
			log("wrote to disk",keys_to_write.length,"entries of run cache =>",
				"new this.toWriteToDiskDict.length=",this.toWriteToDiskDict.length,
				"\n\n\n")
		}
		*/

		// use queue that will run only once per second
		queue.add(async () => {
			if (!this.toWriteToDiskDict) return;

			// Extract with copy to avoid conflicting edit issues
			let _toWriteToDiskDict = deepcopy(this.toWriteToDiskDict);
			let keys_to_write = Object.keys(_toWriteToDiskDict);

			keys_to_write.forEach((key) => {
				delete this.toWriteToDiskDict[key];
			});
			await this.filestore.set(_toWriteToDiskDict);  // this will freeze the app briefly, don't do it too often

			log(
				"wrote to disk",
				keys_to_write.length,
				"entries of run cache =>",
				"new toWriteToDiskDict size=",
				Object.keys(this.toWriteToDiskDict).length,
				"\n keys_to_write=",
				keys_to_write
			);

			// if we already wrote everything to disk => empty queue
			if (Object.keys(this.toWriteToDiskDict).length === 0) {
				// log("nothing to write to disk anymore, clearing queue.")
				queue.clear();
			}
		})
	}
}

export function get_store_WalletHistoryCache(filename) {
	return get_filestore(filename, "WalletHistoryCache")
}

// see https://github.com/sindresorhus/electron-store
export function get_filestore(filename, foldername = undefined) {
	const function_id = "get_filestore(): "
	const log = getLog(function_id)

	/* TODO if is_web_app==true we need to return another version
	either we just mock and do nothing in the functions
	or we handle the functions in localStorage instead ?
	*/

	// if (process.env.NODE_ENV === "production") {
	if (!Constants.IS_WEB_BUILD) {
		try {
			log("creating filestore...");
			const config = {
				name: filename, // file name (default: "config.json")
				cwd: foldername, // folder name (default: "/")
			}
			const store = new electronStoreConnector(config)
			log("store.path=", store.path)

			return store;
		} catch (error) {
			throw new Error(function_id + error)
		}
	}
	log("returning null because we are not in production (or this is a web build)")
	return null; //throw new Error(function_id+" cannot create store when not in production")
}

class electronStoreConnector {
	/* this class is a connector thar interacts with ipcRenderer to mock an electronStore as if it was called from ipcMain
	*/
	constructor(options) {
		this.options = options
		var metadatas, res
		[metadatas, res] = window.electron.callElectronStore(this.options)
		this._update_metadatas(metadatas)
		// don't return here, or "return this"
	}
	_update_metadatas(metadatas) {
		this.store = metadatas.store
		this.size = metadatas.size
		this.path = metadatas.path
	}
	set(...params) {
		var metadatas, res
		[metadatas, res] = window.electron.callElectronStore(this.options, "set", ...params)
		this._update_metadatas(metadatas)
		return res
	}
	get(...params) {
		var metadatas, res
		[metadatas, res] = window.electron.callElectronStore(this.options, "get", ...params)
		this._update_metadatas(metadatas)
		return res
	}
	delete(...params) {
		var metadatas, res
		[metadatas, res] = window.electron.callElectronStore(this.options, "delete", ...params)
		this._update_metadatas(metadatas)
		return res
	}
	reset(...params) {
		var metadatas, res
		[metadatas, res] = window.electron.callElectronStore(this.options, "reset", ...params)
		this._update_metadatas(metadatas)
		return res
	}
	clear(...params) {
		var metadatas, res
		[metadatas, res] = window.electron.callElectronStore(this.options, "clear", ...params)
		this._update_metadatas(metadatas)
		return res
	}
}
